import { render, staticRenderFns } from "./BorrowingReturn.vue?vue&type=template&id=c8f563e0"
import script from "./BorrowingReturn.vue?vue&type=script&lang=js"
export * from "./BorrowingReturn.vue?vue&type=script&lang=js"
import style0 from "./BorrowingReturn.vue?vue&type=style&index=0&id=c8f563e0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports